import "./index.scss";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Chip } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { useState } from "react";

const DefinedProgramContainer = ({ headerInfo, children }) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion
      expanded={expanded === "panel"}
      onChange={handleChange("panel")}
      className="program-accordion-container"
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel4bh-content"
        id="panel4bh-header"
      >
        <div style={{ flexShrink: 0, width: "100%" }}>
          <Box display="flex" gap={1} alignItems="center">
            <label className="section-title">{headerInfo.title}</label>
            {headerInfo.tags.map((tag, i) => {
              if (tag.type === "green") {
                return <Chip key={i} label={tag.text} className="green-bg-chip" />;
              } else {
                return <Chip key={i} label={tag.text} className="orange-bg-chip" />;
              }
            })}
          </Box>
          <p className="accordion-header-subtitle">{headerInfo.subtitle}</p>
        </div>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default DefinedProgramContainer;
